export default class DefaultException extends Error {
  code: string

  constructor(message: string, code: string = 'DefaultException') {
    super(message)
    this.code = code
    this.name = this.constructor.name
  }
}
